import { all, put, take } from "redux-saga/effects";

import {
  groups,
  permissions,
  policies,
  products,
  resources,
  resourceTypes,
  roles,
  services,
  users} from "../policies/actions";
import { FETCH_PRODUCTS_SUCCESS } from "../policies/constants";

/**
 * Fetch initial data in parallel.
 */
export default function* fetchInitialData() {
  // block on first request to prevent potential bug
  // where bakeryjs spawns n 'visit' tabs per request
  // if macaroon changes on server.
  // See: https://github.com/juju/bakeryjs/issues/6
  yield put(products.request());
  yield take(FETCH_PRODUCTS_SUCCESS);
  yield all([
    put(services.request()),
    put(resources.request()),
    put(resourceTypes.request()),
    put(roles.request()),
    put(users.request()),
    put(groups.request()),
    put(policies.request()),
    put(permissions.request())
  ]);
}
